import React, { FunctionComponent } from "react";
import styles from "./EmbedHtml.module.scss";
import EmbedHtmlProps from "./EmbedHtml.interface";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import combineClasses from "helpers/combine-classes";
import RichText from "app/umbraco/helpers/RichText/RichText";

const EmbedHtml: FunctionComponent<EmbedHtmlProps> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);
    
    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {props.content.htmlElement ? (
                    <RichText className={styles.text} innerHtml={props.content.htmlElement} />
                ) : null}
            </div>
        </div>
    );
};

export default EmbedHtml;